import { css } from 'linaria';

export const newBathroomGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;


export const newBathroomGalleryCatalogGrid = css`
  && {
    grid-template-columns: 578px 578px;
    grid-template-rows: 398px 272px 109px auto;

    @media (--only-desktop) {
      grid-template-columns: 458px 458px;
      grid-template-rows: 327px 207px 96px auto;
    }

    @media (--only-tablet) {
      grid-template-columns: 318px 318px;
      grid-template-rows: 230px 154px 52px auto;
    }

    @media (--only-mobile) {
      grid-template-columns: 1fr;
      grid-template-rows: 258px 113px auto;
      margin-bottom: 24px;
    }
  }
`;

export const newBathroomGallerySectionMoreBtn = css`
  && {
    display: block;
    margin: 0 auto;

    @media (--only-mobile) {
      width: 100%;
      border-radius: var(--rounding-m);
    }
  }
`;